import { FC } from "react";
import { stylesheet } from "typestyle";
import { Flex } from "../../../elements/flex.element";
import { Button } from "../../../elements/button.element";

type Props = {
  values: string[];
};

const ValueIdentificationOverviewView: FC<Props> = ({ values }) => (
  <Flex
    flex={1}
    justifyContent="center"
    alignItems="center"
    direction="column"
    attributes={{ style: { marginBottom: 50 } }}
  >
    <h3 style={{ textAlign: "center", margin: 0 }}>Activity Completed</h3>
    <p className={styles.info}>
      Here are your top 5 Values. Write them down or take a screenshot so you
      can come back to them.
    </p>
    <Flex
      direction="column"
      justifyContent="flex-start"
      flex={1}
      style={{ gap: 15, flexWrap: "wrap" }}
    >
      {values.map((value, index) => (
        <Flex key={value + index} attributes={{ className: styles.card }}>
          {value}
        </Flex>
      ))}
    </Flex>
    {
      // condtionally render a button to close the window if in a popup
      window.opener && (
        <Button centerChildren attributes={{ onClick: () => window.close() }}>
          Close
        </Button>
      )
    }
  </Flex>
);

export { ValueIdentificationOverviewView };

const styles = stylesheet({
  info: {
    fontSize: ".9em",
    color: "rgb(var(--rgb-color-text-tertiary))",
    textAlign: "center",
    margin: 0,
  },

  card: {
    borderRadius: 15,
    boxShadow: "0 2px 5px 0 rgba(var(--rgb-color-black), 0.1)",
    backgroundColor: "rgb(var(--rgb-color-white))",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    border: "1px solid transparent",
    textAlign: "center",
  },
});
